import { useTable } from "react-table";
import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import primaryComponents from "../../../primaryComponents";
import {
  convertToTilteCase,
  formatCurrency,
  formatDateDayMonth,
} from "../../../../helpers";
import MoreActions from "./MoreAction";
import secondaryComponents from "../..";
import { pathConstants } from "../../../../routes/pathContants";

export const useCustomersTable = ({ customers, isViaSellMode = false }) => {
  const navigate = useNavigate();
  const [isCustomerDeleteProperties, setIsCustomerDeleteProperties] =
    useState(null);

  const columns = useMemo(
    () => [
      {
        Header: "Full Name",
        accessor: "full_name",
        Cell: ({ cell: { value, row } }) => (
          <>
            {!isViaSellMode ? (
              <Link
                className="purple--text"
                to={`${row.original["id"]}`}
                style={{ fontSize: "12px", textDecoration: "underline" }}
              >
                {value ? convertToTilteCase(value) : "N/A"}
              </Link>
            ) : value ? (
              convertToTilteCase(value)
            ) : (
              "N/A"
            )}
          </>
        ),
      },
      // {
      //   Header: "Email Address",
      //   accessor: "email",
      //   Cell: ({ cell: { value } }) => (value ? value : "N/A"),
      // },
      {
        Header: "Phone Number",
        Cell: ({ row }) =>
          row?.original?.phone
            ? "(+" + row?.original?.phone_code + ") " + row?.original?.phone
            : "N/A",
      },
      {
        Header: "Date of Birth",
        accessor: "date_of_birth",
        Cell: ({ cell: { value } }) =>
          formatDateDayMonth(value, { includeYear: false }) || "N/A",
      },
      {
        Header: "Total Amount Spent",
        accessor: "total_purchases",
        Cell: ({ cell }) =>
          cell.value
            ? formatCurrency({
                value: cell?.value || 0,
                currencyCode: cell?.row?.original?.store?.currency_code,
              })
            : "N/A",
      },
      {
        Header: "Debt/Deposit",
        accessor: "outstanding_balance",
        Cell: ({ cell }) => {
          let val = formatCurrency({
            value: cell.value,
            currencyCode: cell?.row?.original?.store?.currency_code,
          });

          if (cell.value > 0) {
            return (
              <span
                style={{
                  color: "#FD561F",
                }}
              >
                -{val}
              </span>
            );
          } else {
            return (
              <span
                style={{
                  color: "#19AE57",
                }}
              >
                {formatCurrency({
                  value: Math.abs(cell.value),
                  currencyCode: cell?.row?.original?.store?.currency_code,
                })}
              </span>
            );
          }
        },
      },
      {
        Header: "Date Created",
        accessor: "created_at",
        Cell: ({ cell: { value } }) => formatDateDayMonth(value) || "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div className="d-flex flex-wrap align-items-center">
            <primaryComponents.Button
              classNames={"btn btn--outline smallBtn mr-3"}
              onClick={() => {
                navigate(
                  pathConstants.CUSTOMER_EDIT({
                    customerId: row?.original?.id,
                  }),
                );
              }}
            >
              Edit
            </primaryComponents.Button>

            {!isViaSellMode ? (
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Customers"}
              >
                <secondaryComponents.ToolTipV2 tipText="More Actions">
                  <MoreActions
                    showDeleteModal={() =>
                      setIsCustomerDeleteProperties(row?.original)
                    }
                  />
                </secondaryComponents.ToolTipV2>
              </secondaryComponents.NavigateWithPermission>
            ) : null}
          </div>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: customers });

  return {
    instance,
    isCustomerDeleteProperties,
    setIsCustomerDeleteProperties,
  };
};
